import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    dadosHospede: null,
    imagemHotel: null,
    auto: true,
    emailWebCheckin: null,
    dadosPais: null,
    coresWebCheckin: {
      corPrimaria: '#156CF7',
      corSecundaria: '#3f4849',
      corBotoes: '#156CF7',
    },
  },
  getters: {
  },
  mutations: {
    storePais(state, dados) {
      state.dadosPais = dados;
    },
    storeDadosHospede(state, dados) {
      state.dadosHospede = dados;
    },
    storeImagemHotel(state, dados) {
      state.imagemHotel = dados;
    },
    storeAuto(state, dados) {
      state.auto = dados;
    },
    storeEmail(state, dados) {
      state.emailWebCheckin = dados;
    },
    storeCoresWebCheckin(state, cores) {
      state.coresWebCheckin = cores;
    },
  },
  actions: {
  },
  modules: {
  }
})
